import { ISuperTableOptions } from '@modeso/types__aumico-lib-notes-be';

export interface ISuperTableOptionsDialogData {
    options: ISuperTableOptions | undefined;
    languages: string[];
}
